import { AllAvailableTags, Tag, TagType, Result } from '../types';

export abstract class TagService {
    abstract search(term: string, max: number): Promise<Tag[]>;
    abstract getAllAvailableTags(): Promise<AllAvailableTags>;
    abstract createUserDefinedTags(tagName: string): Promise<Result<Tag,string>>;
    abstract createUserDefinedConditionChangeTag(tagName: string): Promise<Result<Tag,string>>;
}
